import { useLocation } from 'react-router';

import { rotatePageContext } from '~/utils/pageContext';

export default function usePageContextManager() {
  const { pathname } = useLocation();

  rotatePageContext(pathname);
}
